import React from 'react';
import { connect } from 'react-redux';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import { getRankingMPGTB } from '../../../../../actions/entities/mpgtb/users';

class RankingMPGTBWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ranking: null,
            order: 'asc',
            orderType: 'ranking',
        };
    }

    componentDidMount() {
        const CATEGORIES = {
            '1': 'Commerce',
            '2': 'Ingénieur',
            '3': 'Sciences Po',
            '4': 'Droit',
            '5': 'Santé',
            '6': 'Éducation',
            '7': 'Sport',
            '8': 'Journalisme',
            '9': 'Lettres',
            '10': 'Prépa',
            '11': 'Informatique',
            '12': 'Autour du monde',
            '13': 'Arts',
            '14': 'IUT',
        };
        const onSuccess = (response) => {
            this.setState({ ranking: map(response.ranking, r => ({ ...r, category: CATEGORIES[r.category] })) });
        };
        this.props.dispatch(getRankingMPGTB(onSuccess));
    }

    orderRank(type) {
        this.setState({
            ranking: orderBy(this.state.ranking, [type, 'ranking'], [this.state.order]),
            order: this.state.order === 'asc' ? 'desc' : 'asc',
            orderType: type,
        });
    }

    render() {
        const { ranking } = this.state;

        return (
            <div className="box">
                <div className="box-header with-border">
                    <h3 className="box-title pull-left">
                        <i className="fa fa-user-circle-o"/> Ranking
                    </h3><br />
                </div>
                <div className="box-body">
                    <div
                        style={{ overflow: 'auto', marginBottom: '1rem', maxHeight: '700px',  }}
                        className="table-responsive"
                    >
                        <table className="table table-bordered no-margin">
                            <thead>
                                <tr>
                                    <th className="theadRanking" onClick={() => this.orderRank('ranking')}>
                                        Rank
                                    </th>
                                    <th className="theadRanking" onClick={() => this.orderRank('id')}>
                                        Id
                                    </th>
                                    <th className="theadRanking" onClick={() => this.orderRank('category')}>
                                        Category
                                    </th>
                                    <th className="theadRanking" onClick={() => this.orderRank('name')}>
                                        Name
                                    </th>
                                    <th className="theadRanking" onClick={() => this.orderRank('nbSupporter')}>
                                        Supporters
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                map(ranking, ({ ranking, id, category, name, nbSupporter }) => {
                                    return (
                                        <tr>
                                            <th className="text-center">{ranking}</th>
                                            <th className="text-center">{id.split('_')[2]}</th>
                                            <th className="text-center">{category}</th>
                                            <th className="text-center">{name}</th>
                                            <th className="text-center">{nbSupporter}</th>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    dispatch => ({ dispatch })
)(RankingMPGTBWidget);



// WEBPACK FOOTER //
// ./src/pages/Other/MPGTB/Widgets/Ranking/index.js